import { AppRoute } from "app";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useUnsupportedBrowsersRedirect = () => {
  const NOT_SUPPORTED_BROWSERS_REGEX = /UCBrowser|MiuiBrowser/i;
  const userAgent = window.navigator.userAgent;
  const isBrowserUnsupported = !!userAgent?.match(NOT_SUPPORTED_BROWSERS_REGEX);
  const navigate = useNavigate();

  useEffect(() => {
    if (isBrowserUnsupported) {
      navigate(AppRoute.BrowserNotSupported, {
        state: {
          // Replace https:// for correct usage in the redirect intent
          redirect: window.location.href.replace("https://", ""),
        },
      });
    }
  }, [isBrowserUnsupported, navigate]);
};
